import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import Authorization from "../../pages/Authorization/Authorization";
import MainScreen from "../../pages/MainScreen";
import ProfileCard from "../../pages/ProfileCard/ProfileCard";
import LoggedInLayout from "../../shared/components/LoggedInLayout";
import { RedirectAuthorization } from "../../shared/hoc";
import PageNotFound from "../../shared/Ui/PageNotFound/PageNotFound";
import PageErrorMessage from "../../shared/Ui/PageErrorMessage/PageErrorMessage";
import RegistrationUsers from "../../pages/RegisrationUsers/RegistrationUsers";
import CheckList from "../../pages/Check/CheckList";
import OfdList from "../../pages/OFD/Ofd";
import OfdCertificate from "../../pages/OFD/OfdCertificate";
import ErrorCheckList from "../../pages/Check/ErrorCheckList";
import SystemReceiver from "../../pages/SystemReceiver/SystemReceiver";
import CacheClear from "../../pages/Cache/CacheClear";


export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/authorization" element={<Authorization />} />

      <Route
        path="/"
        element={
          <RedirectAuthorization>
            <LoggedInLayout />
         </RedirectAuthorization>
        }
      >
        <Route index element={<MainScreen />} />
        <Route path="main" element={<MainScreen />} />
        <Route path="users" element={<RegistrationUsers />} />
        <Route path="check" element={<CheckList />} />
        <Route path="error-ofd" element={<ErrorCheckList />} />
        <Route path="ofd" element={<OfdList />} />
        <Route path="ofd/certificates" element={<OfdCertificate />} />
        <Route path="systemreceiver" element={<SystemReceiver />} />
        <Route path="cache" element={<CacheClear />} />
        <Route
          path="*"
          element={<PageNotFound />}
        />
        <Route
          path="/error"
          element={<PageErrorMessage />}
        />
      </Route >
      <Route path="/error" element={<PageErrorMessage />} />

      <Route path="*" element={<PageNotFound />} />
    </>,
  ),
);
